// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../../../../../node_modules/@glennsl/bs-json/src/Json.mjs";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as PnMDataSource$PorterinFeature from "../data-source/PnMDataSource.mjs";
import * as PnMRepoConfig$PorterinFeature from "./PnMRepoConfig.mjs";
import * as PnMRepoHelper$PorterinFeature from "../helper/PnMRepoHelper.mjs";
import * as Network$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/Network.mjs";
import * as PnMShiftReqRepoHelper$PorterinFeature from "../helper/PnMShiftReqRepoHelper.mjs";
import * as ApiUtils$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ApiUtils.mjs";

function validateGeoregion(pickup_address, drop_address, mobile_number, product_flow) {
  var requestUrl = PnMDataSource$PorterinFeature.getBoundaryValidatorUrl(undefined);
  var payload = Json.stringify(PnMRepoHelper$PorterinFeature.encodeGeoregionData(pickup_address, drop_address, mobile_number, product_flow));
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMValidateGeoregionApiResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.postRequest(requestUrl, payload, undefined, undefined));
}

function createPnMOrderInterest(form_data) {
  var payload = Json.stringify(PnMRepoHelper$PorterinFeature.encodePnMCreateLeadData(form_data));
  var requestUrl = PnMDataSource$PorterinFeature.getPnmOrderLeadCreationUrl(undefined);
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMCreateOrderInterestApiResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.postRequest(requestUrl, payload, undefined, undefined));
}

function submitPnMShiftReqLocationDetails(form_data, shift_req_id, source) {
  var payload = Json.stringify(PnMShiftReqRepoHelper$PorterinFeature.encodePnMShiftReqAddressData(form_data, shift_req_id, source));
  var requestUrl = PnMDataSource$PorterinFeature.getSubmitPnMShiftReqLocationDetailsUrl(undefined);
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMShiftReqLocationDetailsApiResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.postRequest(requestUrl, payload, undefined, undefined));
}

function submitPnMShiftReqBasicDetails(form_data, shift_req_id) {
  var payload = Json.stringify(PnMShiftReqRepoHelper$PorterinFeature.encodePnMShiftReqBasicDetailsData(form_data, shift_req_id));
  var requestUrl = PnMDataSource$PorterinFeature.getShiftReqSubmissionUrl(undefined);
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMShiftReqBasicDetailsApiResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.postRequest(requestUrl, payload, undefined, undefined));
}

function getPaths(locale) {
  var requestUrl = PnMDataSource$PorterinFeature.getPathsCmsUrl(locale);
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMPathsResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.getRequestV2(requestUrl, undefined, undefined, undefined));
}

function getPageContent(page_path, locale) {
  var requestUrl = PnMDataSource$PorterinFeature.getDataCmsUrl(page_path, locale);
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PnMRepoConfig$PorterinFeature.PnMCityResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.getRequestV2(requestUrl, undefined, undefined, undefined));
}

export {
  validateGeoregion ,
  createPnMOrderInterest ,
  submitPnMShiftReqLocationDetails ,
  submitPnMShiftReqBasicDetails ,
  getPaths ,
  getPageContent ,
}
/* PnMDataSource-PorterinFeature Not a pure module */
